<template>
    <div class="m-shop">
        <div class="title"></div>

        <div class="score-info">
            <div class="info">已拥有：<span class="score-amt">{{ $store.state.userinfo.jjb || 0 }}</span><em class="icon-token"></em></div>
            <!-- <div class="u-btn add-token" @click="buy_token()"></div> -->
            <div class="u-btn reflash" @click="relash()"></div>
        </div>

        <div class="shop-ctrl flex-between-center">
            <div class="u-btn rule" @click="$evt_rule()"></div>
            <div class="u-btn record" @click="call_record()"></div>
        </div>

        <!-- shop pannel -->
        <div class="shop-pannel">
            <div class="goods-list flex-wrap">
                <div class="goods-item" v-for="(goods,index) in goods_list.slice(now_page * perpage , perpage * (now_page + 1))" :key="index">
                    <div class="item-name">{{ goods.giftName }}</div>
                    <div class="goods-pic" v-tips="goods.gameGiftId">
                        <game-item :id="goods.gameGiftId" :num="goods.sendNum" :locked="true"></game-item>
                    </div>
                    <div class="order-num">({{ goods.orderNum }}/{{ goods.max }})</div>
                    <div class="price"><em class="icon-token"></em>X{{ goods.amt }}</div>
                    <div class="u-btn apply" :class="{'disabled' : goods.orderNum == goods.max }" @click="call_trade(goods)"></div>
                    <div class="remark" v-if="goods.p1 == 1">解锁通行证可兑换</div>
                </div>
            </div>

            <!-- page ui -->
            <div class="pages-ui">
                <div class="u-btn page prev" @click="prev" :class="{'disabled' : now_page == 0}"></div>
                <div class="page-item" v-for="n in total" :key="n" :class="{'act' : now_page == n - 1}" @click="page(n - 1)">{{ n }}</div>
                <div class="u-btn page next" @click="next" :class="{'disabled' : now_page == (total - 1)}"></div>
            </div>            
        </div>
        <!-- end -->
    </div>
</template>

<script>
import {
    apiShopList,
    apiTradeRecord,
    apiUserinfo,
} from '@/api/index';

export default {
    data(){
        return {
            goods_list : [],
            now_page : 0,
            perpage : 12,  
            total : 1,          
        }
    },
    mounted (){
        this.render_shop();
    },
    computed :{
        _zid (){
            return this.$store.state.userinfo.areaId;
        },
        ex_list (){
            return this.$store.state.ex_list;
        },           
    },
    watch : {
        _zid : {
            handler(newVal, oldVal) {
                if(newVal != oldVal){
                    this.render_shop();
                }              
            },
            deep: true
        },
        ex_list : {
            handler(newVal, oldVal) {
                this.goods_list = newVal;
                //this.get_score();
            },
            deep: true
        },                                  
    },  
    methods : {
        render_shop (){
            apiShopList().then(
                res => {
                    this.goods_list = res.data;
                    this.$store.commit("$_setExList", res.data);
                    this.total = Math.ceil( res.data.length / this.perpage )
                }
            )
        },
        prev (){
            return this.now_page = Math.max(0,--this.now_page)
        },
        next (){
            if(this.now_page + 1 >= this.total)return;
            return this.now_page = Math.min(this.total,++this.now_page)
        },
        page (index){
            return this.now_page = index;
        },        
        call_record(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }


        },
        buy_token(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            this.$trade_token();
        },
        relash(){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            
            apiUserinfo().then(
                res => {
                    this.$store.commit("$_setUserinfo", res.data); 
                    this.$toast('刷新成功~')        
                },
                rej => {  
                    this.$toast(rej.message)    
                },
            );            
        },
        call_trade(item){
            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }

            if(item.orderNum == item.max)return this.$toast('已兑换至上限')

            this.$trade_modal({ item : item })
        },
        call_record(){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                return this.$bind_modal();
            }
            

            apiTradeRecord().then(
                res => {
                    this.$trade_record({ list : res.data });
                },
                rej => {
                    this.$toast(rej.message)
                }
            )
        },
    },
}
</script>

<style lang="scss" scoped>
.m-shop{
    position: relative;
    // top: -125px;
}

.title{
    width: 670px;
    height: 161px;
    margin: 0 auto 15px;
    background-image: url(~@/assets/images/title-4.png);
}

.score-info{
    position: relative;
    width: 542px;
    height: 56px;
    line-height: 56px;
    margin: 0 auto 20px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/bg-token-info.png);

    .info{
        // padding-left: 125px;
        color: #f9efc2;
        line-height: 56px;
        text-align: center;

        .icon-token{
            width: 40px;
            height: 41px;
            margin-left: 10px;
            background-image: url(~@/assets/images/icon-token.png);
        }

    }
    
    .add-token{
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 166px;
        height: 73px;
        background-image: url(~@/assets/images/btn-buy-token.png);
    }

    .reflash{
        position: absolute;
        right: -50px;
        top: 50%;
        transform: translateY(-50%);
        width: 47px;
        height: 44px;
        background-image: url(~@/assets/images/btn-flash.png);        
    }
}

.shop-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 20px;

    .u-btn{
        margin: 0 14px;
    }

    .rule{
        width: 149px;
        height: 38px;
        background-image: url(~@/assets/images/btn-rule-shop.png);
    }

    .record{
        width: 149px;
        height: 38px;
        background-image: url(~@/assets/images/btn-record.png);            
    }
}

.shop-pannel{
    position: relative;
    width: 706px;
    height: 1513px;
    margin: 10px auto 0;
    padding-top: 48px;
    box-sizing: border-box;
    background-image: url(~@/assets/images/pannel-shop.png);
    


    .goods-list{
        margin: 28px 36px 0;

        .goods-item{
            position: relative;
            width: 198px;
            height: 334px;
            margin: 0 4px 10px;
            padding-top: 25px;
            box-sizing: border-box;
            color: #e2c3a3;
            font-size: 22px;
            text-align: center;
            background-image: url(~@/assets/images/shop-item.png);
        }

        .item-name{
            margin-bottom: 5px;
            padding: 0 8px;
            height: 50px;
            font-size: 22px;
            color: #eedfbc;
        }

        .goods-pic{
            margin: 0 auto;
        }

        .price{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 5px;
            color: #d5772b;

            .icon-token{
                width: 24px;
                height: 25px;
                background-image: url(~@/assets/images/icon-token_sm.png);
            }
        }

        .remark{
            margin-top: 10px;
            font-size: 18px;
            color: #ff3e3e;
        }

        .u-btn.apply{
            width: 170px;
            height: 69px;
            margin: 0 auto;
            background-image: url(~@/assets/images/btn-trade.png);
        }
    }
}

.page.u-btn{
    width:  25px;
    height: 43px;
    background-repeat: no-repeat;
}
.page.u-btn.prev{
    margin-right: 50px;
    background-image: url(~@/assets/images/btn-prev_2.png);
}
.page.u-btn.next{
    margin-left: 50px;
    background-image: url(~@/assets/images/btn-next_2.png);
}

.pages-ui{
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 600px;
    margin: -5px auto;
    color: transparent;
}

.page-item{
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    margin: 0 10px;
    cursor: pointer;
    background-image: url(~@/assets/images/nav-item_2.png);
}

.page-item.act{
    background-image: url(~@/assets/images/nav-act_2.png);
}
</style>